// Popup de bienvenida (10% de descuento), hecho en el tema. Aparece a
// los 20 segundos de haber entrado a la página (o antes si el cliente
// de escritorio mueve el mouse hacia afuera de la ventana, intención de
// salida), se puede cerrar fácil
// (X, tocar fuera, Esc) y respeta al cliente: si lo cierra sin
// suscribirse no vuelve a salir en 7 días; si se suscribe, no vuelve a
// salir nunca más.
(function () {
  var LLAVE = 'tz_popup_bienvenida';
  var DIAS_ANTES_DE_REPETIR = 7;

  var popup = document.querySelector('[data-tz-popup-bv]');
  if (!popup) return;

  function leerEstado() {
    try {
      return JSON.parse(localStorage.getItem(LLAVE) || '{}');
    } catch (e) {
      return {};
    }
  }
  function guardarEstado(estado) {
    try {
      localStorage.setItem(LLAVE, JSON.stringify(estado));
    } catch (e) {}
  }

  var estado = leerEstado();
  if (estado.suscrito) return; // ya se suscribió una vez: nunca más
  if (estado.cerradoEn) {
    var diasPasados = (Date.now() - estado.cerradoEn) / (1000 * 60 * 60 * 24);
    if (diasPasados < DIAS_ANTES_DE_REPETIR) return; // lo cerró hace poco
  }

  var pasoForm = popup.querySelector('[data-tz-popup-bv-paso="form"]');
  var pasoExito = popup.querySelector('[data-tz-popup-bv-paso="exito"]');
  var form = popup.querySelector('.tz-popup-bv__form');

  var yaAbierto = false;
  function abrir() {
    if (yaAbierto) return;
    // No interrumpir si el cliente tiene el carrito abierto.
    if (document.querySelector('cart-drawer.active')) { setTimeout(abrir, 5000); return; }
    yaAbierto = true;
    document.removeEventListener('mouseout', intencionDeSalida);
    popup.hidden = false;
    document.body.classList.add('tz-popup-bv-abierto');
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });
    document.addEventListener('keydown', alTeclear);
  }

  function cerrar() {
    popup.classList.remove('is-visible');
    document.body.classList.remove('tz-popup-bv-abierto');
    document.removeEventListener('keydown', alTeclear);
    setTimeout(function () {
      popup.hidden = true;
    }, 250);
    if (!estado.suscrito) {
      estado.cerradoEn = Date.now();
      guardarEstado(estado);
    }
  }

  function alTeclear(evento) {
    if (evento.key === 'Escape') cerrar();
  }

  popup.querySelectorAll('[data-tz-popup-bv-cerrar]').forEach(function (el) {
    el.addEventListener('click', cerrar);
  });

  if (form) {
    form.addEventListener('submit', function (evento) {
      evento.preventDefault();
      var boton = form.querySelector('.tz-popup-bv__boton');
      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Enviando…';

      fetch(form.action || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      })
        .then(function () {
          // Shopify no da una respuesta JSON para este formulario; si la
          // petición llegó al servidor (sin error de red), el correo ya
          // quedó registrado como suscriptor — mostramos el código.
          estado.suscrito = true;
          guardarEstado(estado);
          pasoForm.hidden = true;
          pasoExito.hidden = false;
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          alert('No se pudo enviar. Revisa tu conexión e intenta de nuevo.');
        });
    });
  }

  // Intención de salida (solo escritorio): el mouse sale por arriba de la ventana.
  function intencionDeSalida(evento) {
    if (evento.clientY <= 0 && !evento.relatedTarget) abrir();
  }
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', intencionDeSalida);
  }

  setTimeout(abrir, 20000);
})();
